import { BidKind } from '@ebalance/proto/bfftypes/v1/bid_kind_pb'
import { Side } from '@ebalance/proto/bfftypes/v1/side_pb'

/**
 * CellKey は (areaCode, side, kind) の一意キー文字列
 * 設計書 §6: `${areaCode}|${side}|${kind}`
 */
export type CellKey = `${number}|${number}|${number}`

export function makeCellKey(
  areaCode: number,
  side: Side,
  kind: BidKind,
): CellKey {
  return `${areaCode}|${side}|${kind}`
}

export function parseCellKey(key: CellKey): {
  areaCode: number
  side: Side
  kind: BidKind
} {
  const [areaCode, side, kind] = key.split('|').map(Number)
  return { areaCode, side: side as Side, kind: kind as BidKind }
}
